import type { SubsidySumupsResponse } from "@/features/subventions/types/subsidy-sumup.types";
import type { SubsidiesResponse, UsageHistoryResponse } from "@/features/subventions/types/subvention.types";
import { fetcher } from "@/shared/lib/fetcher.client";

export const subventionService = {
  getSubsidies: async (): Promise<SubsidiesResponse> => {
    const response = await fetcher.get<SubsidiesResponse>("/employees/subsidies");
    return response.data;
  },

  getUsageHistory: async (perimeterId: string | number, holderId: string | number): Promise<UsageHistoryResponse> => {
    const response = await fetcher.get<UsageHistoryResponse>("/subsidies/history", { params: { perimeter_id: perimeterId, holder_id: holderId } });
    return response.data;
  },

  getSubsidySumups: async (): Promise<SubsidySumupsResponse> => {
    const response = await fetcher.get<SubsidySumupsResponse>("/employees/subsidy_sumups");
    return response.data;
  },
};
